import { Grid } from '@mui/material';
import useTeams from '../hooks/useTeams';
import { getComboBoxOptions } from '../utils/Utils';
import ComboBox, { ComboBoxOption } from './form/controls/ComboBox';
import { storeSelection } from './form/react-hook-form-components/FilterStorage';
import { IFilterOptions } from '../pages/FilterOptions';

interface IFilterOptionsProps {
  team: ComboBoxOption | null;
  roles: ComboBoxOption[];
  proxy: boolean | undefined;
}

interface ITeamFilterProps {
  state: IFilterOptionsProps;
  setState: React.Dispatch<React.SetStateAction<IFilterOptions>>;
  page: string;
}

function Filters(props: ITeamFilterProps) {
  const { data: teams } = useTeams();
  const { setState, state, page } = props;

  const getTeamList = (): ComboBoxOption[] => getComboBoxOptions(teams);

  const handleTeamStateChange = (team: ComboBoxOption | null) => {
    setState({
      ...state,
      team,
    });
    storeSelection(page!, team);
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <ComboBox
          label={'Team'}
          name={'team'}
          onChange={option => handleTeamStateChange(option)}
          value={state.team}
          options={getTeamList()}
        />
      </Grid>
    </Grid>
  );
}

export default Filters;
